import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey:
      process.env.REACT_APP_APPINSIGHTS_KEY || '8bc102ab-977a-4ab9-ad6f-f8777b4ab5fd',
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history: undefined }
    }
  }
});
appInsights.loadAppInsights();

export { appInsights, reactPlugin };
